import { memo } from "react";

import { areEqual } from "react-window";

import { type MyLensesLens } from "../../../gql-generated/types";
import { type VirtualizedListItemProps } from "../../models";
import { LoadableItem } from "../LoadableItem";

import { LensRow } from "./LensRow";

export const LoadableLensRow = memo<VirtualizedListItemProps<MyLensesLens>>(({ index, style, data }) => {
    const { list, onSelect, selectedId } = data;
    const lens = list[index];

    if (!lens) {
        return null;
    }

    return (
        <LoadableItem style={style} data={lens} skeletonHeight={16}>
            <LensRow style={style} lens={lens} onSelect={onSelect} selected={lens.id === selectedId} />
        </LoadableItem>
    );
}, areEqual);
